export default __webpack_public_path__ + "static/media/expl-dissect_04_EN.aa58cfa7.png";